module.exports = __webpack_public_path__ + "templates/lock.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/auth/components/lock/lock.html
// module id = 351
// module chunks = 15